import { useTranslation } from "react-i18next";
import type { ArticlePageArticle } from "../../hooks/useArticleData";
import { SectionTitle } from "../../../../components/ui/SectionTitle";
import { licenseLabel as licenseLabelOf } from "../../../../domains/article/utils/licenseLabel";

interface ArticleSectionKeywordsProps {
  article: ArticlePageArticle;
}

export function ArticleSectionKeywords({
  article,
}: ArticleSectionKeywordsProps) {
  const { t } = useTranslation();
  const keywords = article.keywords.filter((el) => el !== "");
  const license = article.license;
  const licenseLabel = license === null ? null : licenseLabelOf(license);

  if (keywords.length === 0 && licenseLabel === null) return null;

  return (
    <section data-gtm-section="keywords" data-gtm-order="11">
      <SectionTitle title={t("Additional information")} className="mb-4" />
      <div className="mt-6 flex flex-col gap-3">
        {keywords.length > 0 && (
          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-medium uppercase tracking-wide text-[#6a7282]">
              {t("Keywords")}
            </h3>
            <div className="flex flex-wrap gap-2">
              {keywords.map((keyword, index) => (
                <span
                  key={`keyword-${keyword}-${index}`}
                  className="rounded-xl bg-[#f3f4f6] px-3 py-1.5 text-xs font-medium text-[#364153]"
                >
                  {keyword}
                </span>
              ))}
            </div>
          </div>
        )}
        {licenseLabel !== null && (
          <div className="flex flex-col gap-2">
            <h3 className="text-sm font-medium uppercase tracking-wide text-[#6a7282]">
              {t("License")}
            </h3>
            <p className="text-sm text-[#1e2939]">{licenseLabel}</p>
          </div>
        )}
      </div>
    </section>
  );
}
